import {
    Backdrop,
    Fade,
    Modal,
    Box,
    TextField,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    InputLabel,
    Select,
    MenuItem,
  } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
  import { useSelector } from "react-redux";
  import { Cancel } from "@mui/icons-material";
  import rewardApi from "../../api/rewardApi";
  import EmojiPicker from "./EmojiPicker";
  
  let modalStyle = "";

if(window.innerWidth > 768){
  modalStyle = {
    outline: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    overflowY: "auto",
    transform: "translate(-50%, -50%)",
    width: "30%",
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    p: 1,
    height: "70%",
    color: "#999",
  };
} else {
  modalStyle = {
    outline: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    overflowY: "auto",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    p: 1,
    height: "90%",
    color: "#999",
  };
}
  
  let timer;
  const timeout = 500;
  let isModalClosed = false;
  
  const RewardModal = (props) => {
    const [reward, setReward] = useState(props.reward);
    const [name, setName] = useState("");
    const [icon, setIcon] = useState("📃");
  
    useEffect(() => {
      setReward(props.reward);
      setIcon(props.reward !== undefined ? props.reward.icon : "");
      setName(props.reward !== undefined ? props.reward.name : "");
      if (props.reward !== undefined) {
        isModalClosed = false;
      }
    }, [props.reward]);
  
    const onClose = () => {
      isModalClosed = true;
      props.onUpdate(reward);
      props.onClose();
    };

    const onIconChange = async (newIcon) => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          await rewardApi.update(reward.id, { icon: newIcon });
        } catch (err) {
          console.log(err);
        }
      }, timeout);
      reward.icon = newIcon;
      setIcon(newIcon);
      props.onUpdate(reward);
    };
  
    const updateName = async (e) => {
      clearTimeout(timer);
      const newName = e.target.value;
      timer = setTimeout(async () => {
        try {
          await rewardApi.update(reward.id, { name: newName });
        } catch (err) {
          console.log(err);
        }
      }, timeout);
      reward.name = newName;
      setName(newName);
      props.onUpdate(reward);
    };
  
    return (
      <>
        <Modal
          open={reward !== undefined}
          onClose={onClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 500 }}
        >
          <Fade in={reward !== undefined}>
            <Box sx={modalStyle}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <Cancel
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    isModalClosed = true;
                    props.onUpdate(reward);
                    props.onClose();
                  }}
                />
              </Box>
              <Box
                sx={{
                  padding: "0rem 2rem",
                }}
              >
                <Box>
                  Icon
                  <EmojiPicker icon={icon} onChange={onIconChange} />
                </Box>
                <Box sx={{mt:1,}}>
                  Name
                  <TextField
                    value={name}
                    onChange={updateName}
                    placeholder="Untitled"
                    variant="outlined"
                    fullWidth
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-input": { padding: 0 },
                      "& .MuiOutlinedInput-notchedOutline": { border: "unset " },
                      "& .MuiOutlinedInput-root": {
                        fontSize: "1.5rem",
                        fontWeight: "700",
                      },
                      marginBottom: "10px",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Fade>
        </Modal>
      </>
    );
  };
  
  export default RewardModal;
  